import useSWR from 'swr'
import { jsonGetFetcher } from '../src/fetchers'

function useFeedReactions (postId, token) {
  const defaultHook = {
    loading: true,
    data: {
        results: [],
        total: 0
    },
    error: false
  }

  const serverSide = Boolean(typeof window === 'undefined')
  let isNull = false
  if (!token || !postId) isNull = true
  
  const url = `${process.env.API}/feeds/challenge/${postId}/reactions`
  let { data, error, loading, mutate } = useSWR(!isNull && !serverSide ? [url, token] : null, jsonGetFetcher)
  
  if (!data && !error && !loading) return defaultHook

  if (error) {
    console.error('feedReactionsHook', error)
    return { ...defaultHook, error: true, loading: false }
  }

  return {
    loading: false,
    error: false,
    data,
    mutate
  }
}

export default useFeedReactions
